<template>
	<section v-if="!loggedIn">
		<form>
			<div class="fields">
				<div class="field">
					<label for="Token">Passwort</label>
					<input type="password" maxlength="20" name="token" v-model="token" @keydown.enter.prevent="login" placeholder="Passwort">
				</div>
				<div class="field">
					<a title="Login" class="button primary solid" href="#" @click.prevent="login">Login</a>
				</div>
			</div>
		</form>
	</section>
	<section v-else>
		<form>
			<div class="fields">
				<div class="field">
					<label for="stream_name">Name des Spenders (optional)</label>
					<input type="text" @keypress="filterInput($event)" maxlength="20" name="stream_name" v-model="stream_name" placeholder="Name">
				</div>
				<div class="field">
					<label for="price">Preis</label>
					<input type="text" name="price" v-model="price" placeholder="Preis">
				</div>
				<div class="field">
					<a title="Login" class="button w-100 primary solid" href="#" @click.prevent="sendStreamNotification">Absenden</a>
				</div>
				<div v-show="sent" class="field" style="color:green">Stream Notification versendet</div>
			</div>
		</form>
		
	</section>
</template>

<script>
import Vue from 'vue'
export default {
name: 'ToolsView',
mixins:[],
components: {
},
data() {
	return {
		loggedIn:false,
		token:"",
		price:"",
		stream_name:"",
		sent:false
	}
},
methods:{
	login(){
		Vue.axios.post('/tools.php', {
			"token":this.token
		})
		.then(()=>{
			this.loggedIn=true;
		})
		.catch(()=> {
			this.loggedIn=false;
		});
	},
	sendStreamNotification(){
		if(parseFloat(this.price)>0){
			//https://sofareisen.org/donation/donate.php?token=jhsZZb5sb*%23GbvxSms33DDfsI3%23*Y9s&stream_only=1&price=50&stream_name=
			Vue.axios.post('/donation/donate.php', {
				"token":"jhsZZb5sb*#GbvxSms33DDfsI3#*Y9s",
				"stream_only":1,
				"price":parseFloat(this.price),
				"stream_name":this.encode_utf8(this.stream_name)
			})
			.then(()=>{
				this.sent=true;
				setTimeout(() => {
					this.reset();
				}, 3000);
			})
			.catch(()=> {
				this.sent=false;
			});
		}
	},
	reset(){
		this.price="";
		this.stream_name="";
		this.sent=false;
	},
	encode_utf8(s) {
		return unescape(encodeURI(s));
	},
	filterInput($event){
		let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
		if (keyCode!=32 && !(/[0-9a-zA-Z]/i.test($event.key))) { 
			$event.preventDefault();
		}
	}
},
}
</script>

<style scoped>

</style>
